module.exports = __webpack_public_path__ + "static/20180718_114446_optimized-f67feebec65af3aa25e7d470a168e10f.jpg";